export const OPERATION = {
  INSERT: "insert",
  UPDATE: "update",
  INSERT_OR_UPDATE: "insertOrUpdate",
  DELETE: "delete"
};

export const EXECUTION_MODULE = {
  MOBILE: "mobile",
  WATCHER: "watcher",
  BOTH: "both"
};

export const ENTITY_TYPES = {
  AGENT: {
    ID: 1,
    SLUG: "agent"
  },
  SERVICE_LOCAL: {
    ID: 2,
    SLUG: "location"
  },
  ITEM: {
    ID: 3,
    SLUG: "item"
  },
  TASK: {
    ID: 4,
    SLUG: "task"
  },
  CUSTOM_ENTITY: {
    ID: 6,
    SLUG: "customEntityEntry"
  },
  SERVICE_LOCAL_ITEM: {
    ID: 15,
    SLUG: "serviceLocalItem"
  }
};